var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBag = function SvgMoneyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.146 7.437h6.697m-4.956 0L7.198 10.77c-1.049.905-1.764 2.908-2.054 4.162a5.65 5.65 0 0 0 .426 3.739c.568 1.182.458 1.286 1.691 1.997 1.38.795 9.097.795 10.478 0 1.233-.711 1.123-.815 1.69-1.997a5.65 5.65 0 0 0 .427-3.739c-.29-1.254-1.005-3.257-2.054-4.162l-3.7-3.332 2.071-4.173s-1.673.5-2.673 0-1.5.5-2.5 0-2.593-.165-2.72 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5c-1 .5-1.5 2-1 3.5"
  })));
};
export default SvgMoneyBag;